import React from 'react';
import Helmet from 'react-helmet';
import { Grid, Button, Tooltip } from '@material-ui/core';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import InfoSquareBlack from 'assets/icons/info-square-black.svg';
import { selectUser } from 'entities/user/selectors';
import Box from 'retired/Box';
import Img from 'retired/Img';
import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';
import { PageBannerContainer } from 'components/PageBannerContainer/PageBannerContainer';
import ReportsPageBanner from 'assets/pageBanners/reports.avif';

import { reports, SingleBoxInterface } from './reportsDefinition';

const ReportsPage: React.FC<{}> = () => {
  const user = useSelector(selectUser);
  const history = useHistory();

  if (
    user &&
    (!user.hasFeature(Features.REPORTS) ||
      !(
        user.hasPrivilege(Privileges.REPORTS_VIEW) ||
        user.hasPrivilege(Privileges.REPORTS_VIEW_RESTRICTED)
      ))
  ) {
    history.replace('/');
  }

  return (
    <>
      <Helmet title="Reports" />
      <PageBannerContainer color="#FFE5B4" backgroundImage={ReportsPageBanner}>
        <Tooltip
          placement="right"
          title="Optimized for Excel users, please reach out to your Partner Success Manager if you use other tools"
        >
          <div style={{ display: 'flex', width: 'fit-content' }}>
            <h1>Reports</h1>
            <Img
              src={InfoSquareBlack}
              alt="Reports"
              style={{
                height: 'max-content',
                margin: '25px 10px',
              }}
            />
          </div>
        </Tooltip>
        {/* <p style={{ background: '#eec', padding: '5px' }}>
            These are some helpful reports that give you an overview of your social impact program.
          </p> */}
      </PageBannerContainer>

      <div>
        <Grid container>
          {reports.map((item: SingleBoxInterface) => {
            const hasPrivileges = item.privilegeNeeded.length
              ? item.privilegeNeeded
                  .map((privilege: string) => user?.hasPrivilege(privilege))
                  .every(Boolean)
              : true;

            const hasFeatures = item.featuresNeeded?.length
              ? item.featuresNeeded
                  .map((privilege: string) => user?.hasFeature(privilege))
                  .every(Boolean)
              : true;

            return (
              hasPrivileges &&
              hasFeatures && (
                <Grid item lg={4} md={6} sm={12} key={item.type} style={{ padding: 10 }}>
                  <Box style={{ height: 260 }}>
                    <Img src={item.icon} alt={item.title || ''} />
                    <h4>{item.title}</h4>
                    <p style={{ fontSize: 14, letterSpacing: -0.3 }}>{item.text}</p>
                    <Link to={`/reports/${item.family}/${item.type}`}>
                      <Button
                        color="primary"
                        type="button"
                        endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
                      >
                        View
                      </Button>
                    </Link>
                  </Box>
                </Grid>
              )
            );
          })}
        </Grid>
      </div>
    </>
  );
};

export default ReportsPage;
